"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIELDS = void 0;
var FIELDS = exports.FIELDS = {
  DECS: 'decs'
};